import styled from 'styled-components';

import { fullscreenWhite } from 'utils/styles/mixins';

export const Wrapper = styled.div`
  ${fullscreenWhite()}
`;
